module.exports = __webpack_public_path__ + "static/media/main-visual-02.eb3822b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/main-visual-02.mp4
// module id = znDi
// module chunks = 1